import { ValueOf } from '../utilities/types';

const aiGenerationStatuses = {
  CREATED: 'created',
  COMPLETE: 'complete',
  ERROR: 'error',
} as const;

export type AIGenerationStatuses = ValueOf<typeof aiGenerationStatuses>;

export default aiGenerationStatuses;
